import React, { RefObject } from 'react';
import { DangerButton } from './styles';

export type ButtonProps = {
  variant?: 'primary' | 'secondary' | 'danger' | 'responsive';
  type?: 'button' | 'submit' | 'reset' | undefined;
  disabled?: boolean;
  children: React.ReactNode;
  onClick?: (e: any) => void;
  width?: string;
  refButton?: RefObject<HTMLButtonElement>;
};

const Button = ({
  variant,
  children,
  disabled,
  onClick,
  type = 'button',
  width,
  refButton,
}: ButtonProps) => {
  switch (variant) {
    case 'secondary':
      return (
        <button
          // eslint-disable-next-line react/button-has-type
          type={type}
          onClick={onClick}
          ref={refButton}
          disabled={disabled}
          className="mcv3-button--secondary"
          style={{ width }}
        >
          {children}
        </button>
      );
    case 'danger':
      return (
        <DangerButton
          type={type}
          disabled={disabled}
          onClick={onClick}
          width={width}
          ref={refButton}
        >
          {children}
        </DangerButton>
      );
    default:
      return (
        <button
          // eslint-disable-next-line react/button-has-type
          type={type}
          disabled={disabled}
          onClick={onClick}
          style={{ width }}
          ref={refButton}
          className="mcv3-button--primary"
        >
          {children}
        </button>
      );
  }
};

export default Button;
